import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Paper, Grid, Box } from '@material-ui/core';
import { ProgramRegistrationAPI } from '../../../../API/API-programRegistration';
import { ProgramsAPI } from '../../../../API/API-programs';

const normalizeID = (value) => {
  if (!value) return '';
  if (typeof value === 'string') return value;
  if (value._id) return value._id.toString();
  return value.toString();
};

const getProgramName = (programResponse, programID) => {
  const program = programResponse.data.program && programResponse.data.program[0];
  return program && program.name ? program.name : programID;
};

class otherInfo extends Component {
  constructor(props) {
    super(props);
    this.state = {
      familyMembers: [],
    };
  }

  componentDidMount() {
    this.loadRegisteredPrograms();
  }

  componentDidUpdate(prevProps) {
    const { membershipID, programRegistrations } = this.props;
    const previousRegistrationIDs = (prevProps.programRegistrations || []).map(normalizeID).join(',');
    const currentRegistrationIDs = (programRegistrations || []).map(normalizeID).join(',');
    if (prevProps.membershipID !== membershipID || previousRegistrationIDs !== currentRegistrationIDs) {
      this.loadRegisteredPrograms();
    }
  }

  loadRegisteredPrograms = () => {
    const { handleHiddenPrograms, membershipID, programRegistrations } = this.props;
    if (programRegistrations.length > 0) {
      ProgramRegistrationAPI.GET.getAllProgramRegistrations().then((success) => {
        const registrationIDs = new Set(programRegistrations.map(normalizeID).filter(Boolean));
        const programIDs = new Set();
        const matchingRegistrations = success.data.filter((registration) => {
          const paymentStatus = String(registration.paymentStatus || '').toLowerCase();
          const hasFamilyMembers = Array.isArray(registration.familyMembers)
            && registration.familyMembers.length > 0;
          if (!registrationIDs.has(normalizeID(registration._id))
            || paymentStatus !== 'approved'
            || !hasFamilyMembers
            || programIDs.has(registration.programID)) return false;
          programIDs.add(registration.programID);
          return true;
        });
        return Promise.all(matchingRegistrations.map((registration) => (
          ProgramsAPI.GET.getProgramByID(registration.programID)
            .then((programResponse) => ({
              programID: registration.programID,
              programName: getProgramName(programResponse, registration.programID),
            }))
            .catch(() => ({
              programID: registration.programID,
              programName: registration.programID,
            }))
        )));
      }).then((registeredPrograms) => {
        this.setState({ familyMembers: registeredPrograms });
        handleHiddenPrograms(registeredPrograms.length > 0 ? '' : 'hidden');
      }).catch((error) => {
        console.log(error);
        handleHiddenPrograms('hidden');
      });
      return;
    }

    ProgramRegistrationAPI.GET.getOneByMembershipID(membershipID).then((success) => {
      this.setState({ familyMembers: success.data });
      console.log(success.data);
      handleHiddenPrograms('');
    }).catch((error) => {
      console.log(error);
      handleHiddenPrograms('hidden');
    });
  };


  render() {
    const { familyMembers } = this.state;
    const { handleProgramSelection } = this.props;
    return (
      <Paper className="body-boxes">
        <Grid item xs={12} className="attendanceLabel">Registered Programs</Grid>
        <Grid item xs={12}>To view attendance, select a program below. </Grid>
        <Grid item xs={12} className="boxes-spacing">
          <Grid
            container
            spacing={1}
            direction="column"
            justifyContent="flex-start"
            alignItems="flex-start"
          >
            {familyMembers.map((value, index) => (
              <Box
                key={value.programID}
                className="programsLabels"
                onClick={() => handleProgramSelection(value.programID)}
              >
                {value.programName}
              </Box>
            ))}
          </Grid>
        </Grid>
      </Paper>
    );
  }
}

otherInfo.propTypes = {
  handleProgramSelection: PropTypes.func.isRequired,
  handleHiddenPrograms: PropTypes.func.isRequired,
  membershipID: PropTypes.string.isRequired,
  programRegistrations: PropTypes.arrayOf(PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.shape({
      _id: PropTypes.string,
    }),
  ])),
};

otherInfo.defaultProps = {
  programRegistrations: [],
};

export default otherInfo;
